import { VStack } from '@chakra-ui/react';
import { Select } from 'chakra-react-select';
import { Field } from 'formik';
import { useSelector } from 'react-redux';

import { dropDownFormStyle } from 'components/forms/new/formStyles';

import { hourOptions } from '../constants';

const HoursFormatField = ({ values, setFieldValue, FormFieldWithTooltip }) => {
    const { darkMode } = useSelector((state) => state.settings);

    return (
        <FormFieldWithTooltip
            label="Hours"
            tooltipLabel="Choose between 12-hour (AM/PM) or 24-hour time format."
            fieldKey="hoursFormat">
            <Field>
                {({ field }) => (
                    <VStack width="100%" alignItems="normal">
                        <Select
                            {...field}
                            tabSelectsValue
                            openMenuOnFocus
                            options={hourOptions}
                            value={hourOptions.find(
                                (o) => o.id === values?.timeZone?.hourCycle,
                            )}
                            getOptionLabel={(o) => o.name}
                            getOptionValue={(o) => o.id}
                            chakraStyles={dropDownFormStyle(darkMode)}
                            onChange={(e) => {
                                setFieldValue('timeZone', {
                                    ...values?.timeZone,
                                    hourCycle: e.id,
                                    hour12: undefined,
                                });
                            }}
                            selectedOptionColor="brand"
                            size="md"
                        />
                    </VStack>
                )}
            </Field>
        </FormFieldWithTooltip>
    );
};

export default HoursFormatField;
